import React from 'react';
import { Box, Tabs } from '@mantine/core';

type IconProps = {
    size?: number | string;
    stroke?: number | string;
    color?: string;
    className?: string;
    style?: React.CSSProperties;
};

export type ManagementTabDefinition = {
    /** Stable id used as the Tabs value */
    id: string;
    /** Label shown in the tab */
    label: string;
    /** Optional tab icon (Tabler icon component) */
    icon?: React.ComponentType<IconProps>;
    /** Render the panel content */
    render: () => React.ReactNode;
};

export interface ManagementTabsViewProps {
    /** Selected tab id (typically from route) */
    tabId: string;
    /** Called when the user selects a tab */
    onTabChange: (tabId: string) => void;
    /** Tabs to render */
    tabs: ManagementTabDefinition[];
}

export const ManagementTabsView: React.FC<ManagementTabsViewProps> = ({
    tabId,
    onTabChange,
    tabs,
}) => {
    return (
        <Box w="100%">
            <Tabs value={tabId} onChange={(v) => onTabChange(v ?? tabs[0]?.id ?? '')} mb="md">
                <Tabs.List>
                    {tabs.map((t) => {
                        const Icon = t.icon;
                        return (
                            <Tabs.Tab
                                key={t.id}
                                value={t.id}
                                {...(Icon ? { leftSection: <Icon size={18} /> } : {})}
                            >
                                {t.label}
                            </Tabs.Tab>
                        );
                    })}
                </Tabs.List>
                {tabs.map((t) => (
                    <Tabs.Panel key={t.id} value={t.id} pt="md">
                        {t.render()}
                    </Tabs.Panel>
                ))}
            </Tabs>
        </Box>
    );
};

